import { useQuery } from '@tanstack/react-query';
import {
    fetchProductSubscriptionPeriodsV2,
    SubscriptionPeriodPricesContainerOut
} from './fetchProductSubscriptionPeriodsV2';
import { GlobalReactQueryOptions } from '../../config';

export const useProductSubscriptionPeriodsV2 = (productId: string) => {
    return useQuery<SubscriptionPeriodPricesContainerOut>(
        ['subscriptionStartOptionsV2', productId],
        () => fetchProductSubscriptionPeriodsV2(productId),
        { ...GlobalReactQueryOptions }
    );
};
